import React from 'react';
import { injectIntl } from 'react-intl';
import { getStageName, i18nIntl } from '../../../lib/ep';
import { stage_types } from '../../../data/bootstrap_stages';

import AgentCards from '../../ui_items/AgentCards';
import Module from '../../ui_items/Module';
import { BackButton } from '../../builder/ActionButton';

const StageSelector = ({ stages, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	if(stages.length == 0) {
		return (
			<Module
				title="Select a stage"
				actions={<BackButton
					_href={(props.back == undefined) ? null : props.back}
					onClick={(props.back == undefined) ? () => { history.go(-1); } : null}
				/>}
			>
				<div class="midGrayBg gui_is_padded_huge">
					<p>{i18n("There are no stages to select.")}</p>
				</div>
			</Module>
		)
	}

	let formatted_stages = [];
	stages.map((st) => {
		const stage = st.Stage;

		const stage_type = stage_types.find((obj) => (obj.id == stage.promotion_type_id));
		if(stage_type == undefined) return;

		let _full_link = props?.url ?? '';
		_full_link += (_full_link.slice(-1) == '/') ? `${stage.id}` : `/${stage.id}`;

		formatted_stages.push({
			id:'claim_request',
			icon:stage_type.icon_class,
			title:getStageName(stage, i18n),
			ribbons:[[{
				title:i18n(stage_type.name),
				color:'gray',
			}]],
			self:false,
			full_link:_full_link,
			use_route:true,
		});
	});

	return (
		<Module
			title="Select a stage"
			actions={<BackButton
				_href={props.back}
				onClick={(props.back == undefined) ? () => { history.go(-1); } : null}
			/>}
		>
			<div class="midGrayBg gui_is_padded_huge gui_not_padded_in_top">
				<AgentCards
					items={formatted_stages}
				/>
			</div>
		</Module>
	)
}
export default injectIntl(StageSelector);